<template>
  <div class="" id="header" ref="header">
    <div class="radious-sec" :class="showDuplicateForm==1 ? 'bgColorUseform' : ''">
      <div class="header-ds">
        <div class="section-title-wrap">
          <h4 :style="fontSizeStyle">{{surveyMasterDetails.st_survey_name}}</h4>
        </div>
      </div>
      <div class="draft-sec" v-if="surveyMasterDetails && surveyMasterDetails.in_status == 5">
          <h5>Draft Form</h5>
      </div>

      <div class="section-duplicate-form" v-if="showDuplicateForm==1 && showDuplicateButton==1">
        <button @click.prevent="duplicateforms" class="btn btn-whitelable sub-main duplicateform">
          <i class="fas fa-copy useFormIcon"></i> Use Form
        </button>
      </div>
    </div>
    <div class="logo-sec" v-if="surveyDesignDetails && surveyDesignDetails.logoUrl">
      <div :class="[surveyDesignDetails.logo_align == 0 ? 'text-left' : surveyDesignDetails.logo_align == 1 ? 'text-center' : 'text-right']">
        <div class="logo-bar-wrapper">
          <a href="#">
            <img :src="surveyDesignDetails.logoUrl" alt="logo">
          </a>
        </div>
      </div>
    </div>

    <div
        class="fixed-progress"
        v-bind:style="{'display': ifShownDisplay}"
        v-if="totalRequiredQues > 0"
      >
      <div class="progress">
        <vue-circle
          :progress="0"
          :size="48"
          :reverse="false"
          line-cap="square"
          :fill="fill"
          empty-fill="rgba(0, 0, 0, .1)"
          :animation-start-value="0.0"
          :start-angle="4.80"
          insert-mode="append"
          :thickness="6"
          :show-percent="true"
          ref="percentageCountProgressBar"
        ></vue-circle>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../main";
import VueCircle from "vue2-circle-progress";
var { redirectUrl, frontHostName, permissions } = require("../../../config/config.js");
export default {
  name: "Header",
  components: {
    VueCircle
  },
  props: ["ifShownDisplay"],
  computed: {
    ...mapGetters("previewSurvey", [
      "surveyMasterDetails",
      "surveyDesignDetails"
    ])
  },
  //props: ['surveyName', 'surveyDesign'],
  data() {
    return {
      fontSizeStyle: {},
      totalPercentageCompleted: 0,
      totalRequiredQues: 0,
      // fill : { gradient: ["red", "green", "blue"] }
      fill: { color: "#3bb54a" },
      showDuplicateForm: 0,
      showDuplicateButton: 0
    };
  },
  mounted() {
    if(this.$route.query.hasOwnProperty('q') && this.$route.query.q == 'templates')
    {
      this.showDuplicateForm = 1;
    }
    this.data = this.$session.getAll();
    console.log("this.datassss");
    console.log(this.data);
    if(this.data.user_permissions.hasOwnProperty(permissions.VIEWDRAFTSURVEYS))
    {
      this.showDuplicateButton = 1;
    }
    //window.addEventListener("scroll", this.updateStickyHeader);
    EventBus.$on("calculateScrollY", scrollY => {
      this.updateStickyHeader(scrollY);
    });
    EventBus.$on("calculatePercentage", completedQues => {
      if (this.totalRequiredQues > 0)
        this.percentageCalc(completedQues, this.totalRequiredQues);
    });
    EventBus.$on("updateRequiredQues", requiredQues => {
      this.totalRequiredQues = requiredQues
    });
  },
  created() {
    //console.log(this.surveyDesignDetails)
    if (this.surveyMasterDetails.st_survey_name) {
      this.totalRequiredQues = this.surveyMasterDetails.in_total_required_ques;
      if (
        this.surveyMasterDetails.st_survey_name.length > 62 &&
        this.surveyMasterDetails.st_survey_name.length < 121
      ) {
        this.fontSizeStyle = { fontSize: "24px", wordBreak: "break-all" };
      } else if (this.surveyMasterDetails.st_survey_name.length > 121) {
        this.fontSizeStyle = { fontSize: "18px", wordBreak: "break-all" };
      }
    }
  },
  beforeDestroy() {
    EventBus.$off("calculatePercentage");
    EventBus.$off("calculateScrollY");
    EventBus.$off("updateRequiredQues");
  },
  methods: {
    hispec() {
      var parts = window.location.href.split(".");
      let whitelabel = this.$session.get("whitelabel");
      var loc =
        frontHostName +
        process.env.CAKE_BASE_PATH +
        whitelabel +
        process.env.CAKE_SURVEY_PATH;
      // var loc = "http://" + location.hostname + process.env.CAKE_SURVEY_PATH;
      window.location.href = loc;
    },
    updateStickyHeader(scrollY) {
      if (this.$refs.header) {
        // if (window.scrollY > 0) {
        // console.log(scrollY);
        if (parseInt(scrollY) > 0) {
          this.$refs.header.classList.add("sticky");
        } else {
          this.$refs.header.classList.remove("sticky");
        }
      }
    },
    percentageCalc(completedValue, totalValue) {
      this.totalPercentageCompleted = parseInt(
        ((100 * completedValue) / totalValue).toFixed(0)
      );
      this.$refs.percentageCountProgressBar.updateProgress(
        this.totalPercentageCompleted
      );
    },
    async duplicateforms() {
      this.data = this.$session.getAll();
      let whitelabel = this.$session.get("whitelabel");
      let url = process.env.API_PATH + "/APIDuplicateForms";
      this.$wait.start("adding response");
      await axios
        .post(url, {
          'in_survey_id': this.surveyDesignDetails.in_survey_Id,
          'in_subscription_id': this.data.subscriptionId,
          'in_user_id': this.data.requestId
        }, {
          headers: {
            "Content-Type": "applications/json"
          }
        })
        .then(response => {
          this.$wait.end("adding response");
          if (response.data.FLAG === 1) {
              this.$awn.success(response.data.MSG);
              var editformRedirectUrl = redirectUrl + "/" + whitelabel + "/editForms/" + response.data.DATA;
              setTimeout(() => {
                window.location.href = editformRedirectUrl;
              }, 3000);
          }else{
              this.$awn.alert('Something might wrong. Try later');
          }
        })
        .catch();
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Preview/Header.vue